export function schema_zone_final_extract() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			inter_page: {
				title: "Données sur plusieurs pages",
				type: 'boolean',
				format: "checkbox"
			},
			column_name: {
				title: "Colonne des clés",
				type: "string"
			},
			column_file: {
				title: "Colonne de d'url du fichier",
				type: "string"
			}
		},
	};
}
